/**
 * Effects
 */
;(function ($) {
	var vw = $(window).width()
	// var vh = $(window).height()
	/**
	 * Extra wide images on projects indexes
	 */
	function changeWideOrder(vw) {
		if (vw > 767 && vw < 1440) {
			$('.works__item').each(function (i) {
				if ($(this).hasClass('extrawide') && i % 2 !== 0) {
					$(this).css('order', i + 3)
				} else {
					$(this).css('order', i + 1)
				}
			})
		} else {
			$('.works__item').each(function (i) {
				$(this).css('order', i + 1)
			})
		}
	}
	changeWideOrder(vw)
	$(window).resize(function () {
		var rvw = $(window).width()
		changeWideOrder(rvw)
	})

	// In page menu scroll
	$('.menu-anchors a').on('click', function (e) {
		e.preventDefault()
		var goto = $(this).attr('href')
		$('html, body').animate(
			{
				scrollTop: $(goto).offset().top - 160,
			},
			1500
		)
	})

	// url hash scroll
	var hash = window.location.hash
	if (hash) {
		$('html, body').animate(
			{
				scrollTop: $(hash).offset().top - 160,
			},
			1500
		)
	}

	// About thumbnails
	$('.page__content a[data-id]').each(function () {
		var $this = $(this)
		// $this.attr('onmouseover', 'interval()')
		var postid = $this.attr('data-id')
		$.ajax({
			type: 'POST',
			// eslint-disable-next-line no-undef
			url: m_ajaxurl,
			data: {
				action: 'm_load_post_thumbnail',
				postid: postid,
			},
			success: function (data) {
				$this.append(data)
			},
		})
	})

	// hover
	$('.page__content a[data-id]').on('mouseover', function (e) {
		var x = e.pageX
		var y = e.pageY
		var image = $(this).find('.post-thumb')
		if (vw - x < 300) {
			image.css('left', x + -450)
		} else {
			image.css('left', x + 10)
		}
		image.css('top', y + 10)
	})

	// accordion
	$('.accordion__toggle').on('click', function () {
		var $accordion = $(this)
		var label = $accordion.attr('data-label')
		var $content = $accordion.parent().find('.accordion__panel')
		var isExpanded = $accordion.attr('aria-expanded') === 'true'
		$accordion.attr('aria-expanded', !isExpanded).attr('data-label', $accordion.text()).text(label)
		$content.attr('aria-hidden', isExpanded).slideToggle()
	})

	// people list
	$('.people-list__person').on('click', function (e) {
		e.preventDefault()
		$('#' + $(this).attr('href')).trigger('click')
	})
})(jQuery)
